import { ApiClientFormData } from './ApiClientFormData';
import { ApiClientJson } from './ApiClientJson';
import { createHttpClient } from './HttpClient';
import { type ApiClient } from './ApiClients';

type BodyType = 'json' | 'formData';

export function getApiClientByBodyType(type: 'json'): ApiClient<object>;
export function getApiClientByBodyType(type: 'formData'): ApiClient<FormData>;

export function getApiClientByBodyType(type: BodyType): ApiClient<unknown> {
  if (type === 'json') {
    return new ApiClientJson(createHttpClient());
  } else if (type === 'formData') {
    return new ApiClientFormData(createHttpClient());
  }
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  throw new Error(`Unsupported body type: ${type}`);
}
